import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import {
  queryDeleteRole,
  queryRoleInfo,
  queryRoleList,
  querySaveRole,
  querySaveRoleFunc,
  querySaveRoleUserByRole,
} from '@api/core/role';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import moment from 'moment';
import ModalRoleAdd from './ModalRoleAdd';
import ModalRoleFuncAdd from './ModalRoleFuncAdd';
import ModalRoleUserAdd from './ModalRoleUsercAdd';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      pageSize: 15,
      isPermission: false,
      visible: false,
      funcRelateVisible: false,
      userRelateVisible: false,
      dataInfo: null,
    };
  }

  componentDidMount() {
    this.loadData(1);
    this.judge(this.props.account_info);
  }

  componentWillUnmount() {
    this.props.dispatch(setBackInfo({}));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  loadData = (pageNo, pageSize) => {
    this.setState({
      isLoading: true,
    });
    const params = {};
    const { condition, pageNo: no } = this.state;
    const current = pageNo || no;
    params.limit = pageSize || 15;
    params.start = current;
    params.condition = condition || '';
    queryRoleList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          isLoading: false,
          total: res.totalSize,
          pageNo: current,
        });
      }
    });
  };

  // 菜单栏详情
  getRoleInfo = uuid => {
    queryRoleInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  saveRole = params => {
    querySaveRole(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerVisible(false);
        this.setState({ dataInfo: null });
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  saveRoleFunc = (roleUuid, functionUuids, callback) => {
    querySaveRoleFunc({ roleUuid, funcUuids: functionUuids }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerFuncRelateVisible(false, callback);
      } else {
        message.error(res.message);
      }
    });
  };

  saveRoleUser = (roleUuid, accountUuids, callback) => {
    querySaveRoleUserByRole({ roleUuid, accountUuids }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerUserRelateVisible(false, callback);
      } else {
        message.error(res.message);
      }
    });
  };

  deleteRole = uuid => {
    queryDeleteRole({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData();
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = accountInfo => {
    let isPermission = false;
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  handlerVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handlerFuncRelateVisible = (flag, callback) => {
    this.setState(
      {
        funcRelateVisible: !!flag,
      },
      callback,
    );
  };

  handlerUserRelateVisible = (flag, callback) => {
    this.setState(
      {
        userRelateVisible: !!flag,
      },
      callback,
    );
  };

  addRole = () => {
    this.setState({ dataInfo: null });
    this.handlerVisible(true);
  };

  addRoleFunc = uuid => {
    this.setState({ roleUuid: uuid }, this.handlerFuncRelateVisible(true));
  };

  addRoleUser = uuid => {
    this.setState({ roleUuid: uuid }, this.handlerUserRelateVisible(true));
  };

  editRole = uuid => {
    this.getRoleInfo(uuid);
    this.handlerVisible(true);
  };

  columns = () => {
    return [
      {
        title: '角色名称',
        dataIndex: 'name',
      },
      {
        title: '角色状态',
        dataIndex: 'status',
        render: text => {
          return <span>{text === 1 ? '启用' : '禁用'}</span>;
        },
      },
      {
        title: '创建日期',
        dataIndex: 'createDate',
        render: text => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-dd HH:mm:ss')}</span>;
        },
      },
      {
        title: '业务系统名称',
        dataIndex: 'crappUuid',
        render: text => {
          return <span>{text === 'bszb' ? '帮实资本投资管理决策系统' : '系统平台'}</span>;
        },
      },
      {
        title: '备注',
        dataIndex: 'remark',
      },
      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              {isPermission ? (
                <span>
                  <a onClick={() => this.editRole(record.uuid)}>编辑</a>
                  <span className="ant-divider" />
                  <a onClick={() => this.addRoleFunc(record.uuid)}>角色定义</a>
                  <span className="ant-divider" />
                  <a onClick={() => this.addRoleUser(record.uuid)}>角色用户授权</a>
                  <span className="ant-divider" />
                  <Popconfirm
                    onConfirm={() => this.deleteRole(record.uuid)}
                    title="确定删除当前菜单栏吗？"
                    placement="topRight"
                    overlayStyle={{ width: 200 }}
                  >
                    <a className="ant-dropdown-link">删除</a>
                  </Popconfirm>
                </span>
              ) : null}{' '}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const {
      data,
      isLoading,
      total,
      pageNo,
      pageSize,
      isPermission,
      visible,
      funcRelateVisible,
      userRelateVisible,
      dataInfo,
      roleUuid,
    } = this.state;
    const pagination = {
      showSizeChanger: true,
      pageSize,
      total,
      current: pageNo,
      pageSizeOptions: ['10', '50', '100', '200', '500'],
      onShowSizeChange: (current, size) => {
        this.loadData(current, size);
      },
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Card>
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {isPermission ? (
                <Button type="primary" onClick={() => this.addRole('')}>
                  添加
                </Button>
              ) : null}
            </Col>
            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
          <Table
            rowKey="uuid"
            loading={isLoading}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
          <ModalRoleAdd
            visible={visible}
            data={dataInfo}
            onOk={params => this.saveRole(params)}
            onCancel={() => this.handlerVisible(false)}
          />
          <ModalRoleFuncAdd
            visible={funcRelateVisible}
            roleUuid={roleUuid}
            onOk={(uuid, selectedKeys, callback) => this.saveRoleFunc(uuid, selectedKeys, callback)}
            onCancel={() => this.handlerFuncRelateVisible(false)}
          />
          <ModalRoleUserAdd
            visible={userRelateVisible}
            roleUuid={roleUuid}
            onOk={(accountUuids, callback) => this.saveRoleUser(roleUuid, accountUuids, callback)}
            onCancel={() => this.handlerUserRelateVisible(false)}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/boss/role/Index.js